export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11139.9f557bdb.jpg";